import React from "react";
import "./Terms.css";

function PrivacyPolicy() {
    return (
        <div className="terms-page">
            <div className="terms-container">

                <h1>Privacy Policy</h1>

                <p className="intro">
                    At <strong>TIK HR Consultancy</strong>, we value your privacy and are
                    committed to protecting your personal information. This Privacy Policy
                    explains how we collect, use, store, and safeguard your information
                    when you use our website and services.
                </p>

                <section>
                    <h2>Information We Collect</h2>

                    <p>We may collect the following information:</p>

                    <ul>
                        <li>Full Name</li>
                        <li>Mobile Number</li>
                        <li>Email Address</li>
                        <li>Residential Address</li>
                        <li>Educational Qualifications</li>
                        <li>Resume / CV</li>
                        <li>Identity Proof</li>
                        <li>Passport Details (where applicable)</li>
                        <li>Photographs</li>
                        <li>Employment Information</li>
                        <li>IP Address</li>
                        <li>Browser Information</li>
                        <li>Device Information</li>
                    </ul>
                </section>

                <section>
                    <h2>How We Use Your Information</h2>

                    <p>Your information may be used to:</p>

                    <ul>
                        <li>Register candidates</li>
                        <li>Provide training</li>
                        <li>Schedule interviews</li>
                        <li>Share suitable job opportunities</li>
                        <li>Verify eligibility</li>
                        <li>Communicate updates</li>
                        <li>Improve our services</li>
                        <li>Comply with legal obligations</li>
                    </ul>
                </section>

                <section>
                    <h2>Sharing of Information</h2>

                    <p>We may share candidate information with:</p>

                    <ul>
                        <li>Employers</li>
                        <li>Recruitment Partners</li>
                        <li>Training Partners</li>
                        <li>Verification Agencies</li>
                        <li>Government Authorities where legally required</li>
                    </ul>

                    <p>
                        We do not sell, rent, or trade your personal information to third
                        parties.
                    </p>
                </section>

                <section>
                    <h2>Cookies</h2>

                    <p>Our website may use cookies to:</p>

                    <ul>
                        <li>Improve website functionality</li>
                        <li>Remember user preferences</li>
                        <li>Analyze website traffic</li>
                        <li>Enhance user experience</li>
                    </ul>

                    <p>
                        Users may disable cookies through their browser settings if they
                        prefer.
                    </p>
                </section>

                <section>
                    <h2>Data Security</h2>

                    <p>
                        We implement reasonable technical and organizational measures to
                        protect personal information against unauthorized access,
                        disclosure, alteration, or destruction.
                    </p>

                    <p>
                        While we strive to safeguard your information, no method of
                        transmission over the internet or electronic storage is completely
                        secure.
                    </p>
                </section>

                <section>
                    <h2>Data Retention</h2>

                    <p>
                        We retain personal information only for as long as necessary to
                        provide our services, comply with legal obligations, resolve
                        disputes, or enforce our agreements.
                    </p>
                </section>

                <section>
                    <h2>User Rights</h2>

                    <p>Users may request:</p>

                    <ul>
                        <li>Access to their personal information</li>
                        <li>Correction of inaccurate information</li>
                        <li>Deletion of personal data where legally permissible</li>
                        <li>Withdrawal of consent where applicable</li>
                    </ul>

                    <p>
                        Requests may be submitted by emailing
                        <strong> info@tikhr.com</strong>.
                    </p>
                </section>

                <section>
                    <h2>Children's Privacy</h2>

                    <p>
                        Our services are only intended for candidates above the age of 18
                        with parental consent.
                    </p>
                </section>

                <section>
                    <h2>Policy Updates</h2>

                    <p>
                        We may update this Privacy Policy from time to time. The latest
                        version will always be available on our website along with the
                        updated effective date.
                    </p>
                </section>

            </div>
        </div>
    );
}

export default PrivacyPolicy;